import App from './src/App'
import {createRouter, createWebHistory} from "vue-router";
import {useApiStore} from "@/stores/ApiStore";

const routes = [
    {
        name: 'dashboard',
        path: '/',
        component: App
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})



router.beforeEach(async (to) => {
    const apiDataStore = useApiStore()
    apiDataStore.setApiKey(to.query.apiKey)
    apiDataStore.setLang(to.query.lang)
})

export default router